// eslint-disable
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const en_widget_referral_extra_entries = /** @type {(inputs: { count: NonNullable<unknown>, entries: NonNullable<unknown> }) => string} */ (i) => {
	return `You'll get ${i.count} extra ${i.entries} for anyone that enters via this link:`
};

const de_widget_referral_extra_entries = /** @type {(inputs: { count: NonNullable<unknown>, entries: NonNullable<unknown> }) => string} */ (i) => {
	return `Du erhältst ${i.count} zusätzliche ${i.entries} für jede Person, die über diesen Link teilnimmt:`
};

const es_widget_referral_extra_entries = /** @type {(inputs: { count: NonNullable<unknown>, entries: NonNullable<unknown> }) => string} */ (i) => {
	return `Obtendrás ${i.count} ${i.entries} adicionales por cada persona que se una a través de este enlace:`
};

const fr_widget_referral_extra_entries = /** @type {(inputs: { count: NonNullable<unknown>, entries: NonNullable<unknown> }) => string} */ (i) => {
	return `Vous obtiendrez ${i.count} ${i.entries} supplémentaires pour toute personne qui participe via ce lien:`
};

const fi_widget_referral_extra_entries = /** @type {(inputs: { count: NonNullable<unknown>, entries: NonNullable<unknown> }) => string} */ (i) => {
	return `Saat ${i.count} ylimääräistä ${i.entries} jokaisesta henkilöstä, joka osallistuu tämän linkin kautta:`
};

const hi_widget_referral_extra_entries = /** @type {(inputs: { count: NonNullable<unknown>, entries: NonNullable<unknown> }) => string} */ (i) => {
	return `इस लिंक के जरिए आने वाले हर व्यक्ति के लिए आपको ${i.count} अतिरिक्त ${i.entries} मिलेंगी:`
};

const ja_widget_referral_extra_entries = /** @type {(inputs: { count: NonNullable<unknown>, entries: NonNullable<unknown> }) => string} */ (i) => {
	return `このリンク経由で参加した方1人につき${i.count}個の追加${i.entries}を獲得できます:`
};

const nl_widget_referral_extra_entries = /** @type {(inputs: { count: NonNullable<unknown>, entries: NonNullable<unknown> }) => string} */ (i) => {
	return `Je krijgt ${i.count} extra ${i.entries} voor iedereen die via deze link meedoet:`
};

const pt_widget_referral_extra_entries = /** @type {(inputs: { count: NonNullable<unknown>, entries: NonNullable<unknown> }) => string} */ (i) => {
	return `Você receberá ${i.count} ${i.entries} extras para qualquer pessoa que participar através deste link:`
};

const ro_widget_referral_extra_entries = /** @type {(inputs: { count: NonNullable<unknown>, entries: NonNullable<unknown> }) => string} */ (i) => {
	return `Vei primi ${i.count} ${i.entries} suplimentare pentru oricine intră prin acest link:`
};

const th_widget_referral_extra_entries = /** @type {(inputs: { count: NonNullable<unknown>, entries: NonNullable<unknown> }) => string} */ (i) => {
	return `คุณจะได้รับ ${i.count} ${i.entries} เพิ่มเติมสำหรับใครก็ตามที่เข้าร่วมผ่านลิงก์นี้:`
};

const ur_widget_referral_extra_entries = /** @type {(inputs: { count: NonNullable<unknown>, entries: NonNullable<unknown> }) => string} */ (i) => {
	return `اس لنک کے ذریعے شرکت کرنے والے ہر شخص کے لیے آپ کو ${i.count} اضافی ${i.entries} ملیں گے:`
};

const zh_hant1_widget_referral_extra_entries = /** @type {(inputs: { count: NonNullable<unknown>, entries: NonNullable<unknown> }) => string} */ (i) => {
	return `透過此連結參與的每個人，您將獲得 ${i.count} 個額外的${i.entries}：`
};

const da_widget_referral_extra_entries = /** @type {(inputs: { count: NonNullable<unknown>, entries: NonNullable<unknown> }) => string} */ (i) => {
	return `Du får ${i.count} ekstra ${i.entries} for alle der deltager via dette link:`
};

const it_widget_referral_extra_entries = /** @type {(inputs: { count: NonNullable<unknown>, entries: NonNullable<unknown> }) => string} */ (i) => {
	return `Otterrai ${i.count} ${i.entries} extra per chiunque partecipi tramite questo link:`
};

const vn_widget_referral_extra_entries = /** @type {(inputs: { count: NonNullable<unknown>, entries: NonNullable<unknown> }) => string} */ (i) => {
	return `Bạn sẽ nhận được ${i.count} ${i.entries} bổ sung cho mỗi người tham gia qua liên kết này:`
};

const ko_widget_referral_extra_entries = /** @type {(inputs: { count: NonNullable<unknown>, entries: NonNullable<unknown> }) => string} */ (i) => {
	return `이 링크를 통해 참여하는 사람마다 ${i.count}개의 추가 ${i.entries}를 받게 됩니다:`
};

const tr_widget_referral_extra_entries = /** @type {(inputs: { count: NonNullable<unknown>, entries: NonNullable<unknown> }) => string} */ (i) => {
	return `Bu bağlantı üzerinden katılan herkes için ${i.count} ek ${i.entries} kazanacaksınız:`
};

const lv_widget_referral_extra_entries = /** @type {(inputs: { count: NonNullable<unknown>, entries: NonNullable<unknown> }) => string} */ (i) => {
	return `Jūs saņemsiet ${i.count} papildu ${i.entries} par ikvienu, kas ievadīs šo saiti:`
};

const ar_widget_referral_extra_entries = /** @type {(inputs: { count: NonNullable<unknown>, entries: NonNullable<unknown> }) => string} */ (i) => {
	return `ستحصل على ${i.count} ${i.entries} إضافية لكل شخص يدخل عبر هذا الرابط:`
};

const bs_widget_referral_extra_entries = /** @type {(inputs: { count: NonNullable<unknown>, entries: NonNullable<unknown> }) => string} */ (i) => {
	return `Dobićete ${i.count} dodatnih ${i.entries} za svakog ko uđe preko ovog linka:`
};

const sl_widget_referral_extra_entries = /** @type {(inputs: { count: NonNullable<unknown>, entries: NonNullable<unknown> }) => string} */ (i) => {
	return `Dobili boste ${i.count} dodatnih ${i.entries} za vsakogar, ki vstopi prek te povezave:`
};

const id_widget_referral_extra_entries = /** @type {(inputs: { count: NonNullable<unknown>, entries: NonNullable<unknown> }) => string} */ (i) => {
	return `Anda akan mendapat ${i.count} ${i.entries} tambahan untuk setiap orang yang masuk melalui tautan ini:`
};

const sv_widget_referral_extra_entries = /** @type {(inputs: { count: NonNullable<unknown>, entries: NonNullable<unknown> }) => string} */ (i) => {
	return `Du får ${i.count} extra ${i.entries} för alla som deltar via denna länk:`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{ count: NonNullable<unknown>, entries: NonNullable<unknown> }} inputs
* @param {{ locale?: "en" | "de" | "es" | "fr" | "fi" | "hi" | "ja" | "nl" | "pt" | "ro" | "th" | "ur" | "zh-Hant" | "da" | "it" | "vn" | "ko" | "tr" | "lv" | "ar" | "bs" | "sl" | "id" | "sv" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
export const widget_referral_extra_entries = (inputs, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.widget_referral_extra_entries(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("widget_referral_extra_entries", locale)
	if (locale === "en") return en_widget_referral_extra_entries(inputs)
	if (locale === "de") return de_widget_referral_extra_entries(inputs)
	if (locale === "es") return es_widget_referral_extra_entries(inputs)
	if (locale === "fr") return fr_widget_referral_extra_entries(inputs)
	if (locale === "fi") return fi_widget_referral_extra_entries(inputs)
	if (locale === "hi") return hi_widget_referral_extra_entries(inputs)
	if (locale === "ja") return ja_widget_referral_extra_entries(inputs)
	if (locale === "nl") return nl_widget_referral_extra_entries(inputs)
	if (locale === "pt") return pt_widget_referral_extra_entries(inputs)
	if (locale === "ro") return ro_widget_referral_extra_entries(inputs)
	if (locale === "th") return th_widget_referral_extra_entries(inputs)
	if (locale === "ur") return ur_widget_referral_extra_entries(inputs)
	if (locale === "zh-Hant") return zh_hant1_widget_referral_extra_entries(inputs)
	if (locale === "da") return da_widget_referral_extra_entries(inputs)
	if (locale === "it") return it_widget_referral_extra_entries(inputs)
	if (locale === "vn") return vn_widget_referral_extra_entries(inputs)
	if (locale === "ko") return ko_widget_referral_extra_entries(inputs)
	if (locale === "tr") return tr_widget_referral_extra_entries(inputs)
	if (locale === "lv") return lv_widget_referral_extra_entries(inputs)
	if (locale === "ar") return ar_widget_referral_extra_entries(inputs)
	if (locale === "bs") return bs_widget_referral_extra_entries(inputs)
	if (locale === "sl") return sl_widget_referral_extra_entries(inputs)
	if (locale === "id") return id_widget_referral_extra_entries(inputs)
	if (locale === "sv") return sv_widget_referral_extra_entries(inputs)
	return "widget_referral_extra_entries"
};